module.exports = __webpack_public_path__ + "img/DE03510.00659357.png";